export default __webpack_public_path__ + "static/media/contact-customer-service.88c717d6.png";